import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,

  // Environment configuration
  environment: import.meta.env.VITE_MODE || "development",

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  integrations: [
    // Session replay for debugging
    Sentry.replayIntegration({
      // Capture console logs, network requests, and DOM events
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],

  // Performance monitoring
  tracesSampleRate: import.meta.env.VITE_MODE === "production" ? 0.1 : 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  // Disable tracing for localhost to avoid CORS issues in development
  tracePropagationTargets: [
    /^https:\/\/.*\.teelogix\.com/,  // Only trace production domains
    /^https:\/\/.*\.ondigitalocean\.app/  // And staging domains
  ],

  // Session replay configuration
  replaysSessionSampleRate: import.meta.env.MODE === "production" ? 0.1 : 1.0,
  replaysOnErrorSampleRate: 1.0,

  // Error filtering
  // beforeSend(event, hint) {
  //   // Filter out errors in development
  //   if (import.meta.env.VITE_MODE === "development") {
  //     console.group("🚨 Sentry Error Captured");
  //     console.error("Event:", event);
  //     console.error("Hint:", hint);
  //     console.groupEnd();
  //   }

  //   // Filter out network errors that are not actionable
  //   if (event.exception) {
  //     const error = hint.originalException;
  //     if (error && error.message) {
  //       // Filter out common browser extension errors
  //       if (error.message.includes("Non-Error promise rejection")) {
  //         return null;
  //       }
  //       // Filter out ResizeObserver errors (common browser issue)
  //       if (error.message.includes("ResizeObserver loop limit exceeded")) {
  //         return null;
  //       }
  //     }
  //   }

  //   return event;
  // },
});
